export default __webpack_public_path__ + "static/media/map.54df5979.jpg";